// This is an automatically generated file. Do not edit.
// See scripts/updatePermissions.ts

export enum Permission {
    AccommodationCreate = "accommodation-create",
    AccommodationDelete = "accommodation-delete",
    AccommodationRead = "accommodation-read",
    AccommodationUpdate = "accommodation-update",
    AfListApproveBoardRead = "af-list-approve-board-read",
    AfListBoardRead = "af-list-board-read",
    AfListBoardUpdate = "af-list-board-update",
    AfListManagerRead = "af-list-manager-read",
    AfListProjectleadRead = "af-list-projectlead-read",
    AfListPublishBoardRead = "af-list-publish-board-read",
    AfListRejectBoardRead = "af-list-reject-board-read",
    AfListReturnBackBoardRead = "af-list-return-back-board-read",
    AfSettingCreate = "af-setting-create",
    AfSettingRead = "af-setting-read",
    AfSettingUpdate = "af-setting-update",
    AmendmentTypeCreate = "amendment-type-create",
    AmendmentTypeDelete = "amendment-type-delete",
    AmendmentTypeRead = "amendment-type-read",
    AmendmentTypeUpdate = "amendment-type-update",
    AttendanceAccountantReportRead = "attendance-accountant-report-read",
    AttendanceCreate = "attendance-create",
    AttendanceEmptyDaysRead = "attendance-empty-days-read",
    AttendanceOperationReportRead = "attendance-operation-report-read",
    AttendanceRead = "attendance-read",
    AttendanceUpdate = "attendance-update",
    BudgetCreate = "budget-create",
    BudgetDelete = "budget-delete",
    BudgetRead = "budget-read",
    BudgetUpdate = "budget-update",
    CanAddEventDocumentLinkCreate = "can-add-event-document-link-create",
    CanApproveAttendanceRead = "can-approve-attendance-read",
    CanApproveFinAttendanceRead = "can-approve-fin-attendance-read",
    CanApproveOpsAttendanceRead = "can-approve-ops-attendance-read",
    CanHandleWaitingForFinEventRead = "can-handle-waiting-for-fin-event-read",
    CanHandleWaitingForOpsEventRead = "can-handle-waiting-for-ops-event-read",
    CanReadAttendanceRead = "can-read-attendance-read",
    CanRejectAttendanceRead = "can-reject-attendance-read",
    CanRejectFinAttendanceRead = "can-reject-fin-attendance-read",
    CanRequestAttendanceRead = "can-request-attendance-read",
    CanSeeAllEventOverviewRead = "can-see-all-event-overview-read",
    CanSeeColleagueEventOverviewRead = "can-see-colleague-event-overview-read",
    CanSeeDepartmentEventOverviewRead = "can-see-department-event-overview-read",
    CanSeeDirectSubordinateEventOverviewRead = "can-see-direct-subordinate-event-overview-read",
    CanSeeIndirectSubordinateEventOverviewRead = "can-see-indirect-subordinate-event-overview-read",
    CanSeeProjectEventOverviewRead = "can-see-project-event-overview-read",
    CoefficientCreate = "coefficient-create",
    CoefficientDelete = "coefficient-delete",
    CoefficientRead = "coefficient-read",
    CoefficientUpdate = "coefficient-update",
    CompanyCreate = "company-create",
    CompanyDelete = "company-delete",
    CompanyGroupCreate = "company-group-create",
    CompanyGroupDelete = "company-group-delete",
    CompanyGroupRead = "company-group-read",
    CompanyGroupUpdate = "company-group-update",
    CompanyRead = "company-read",
    CompanySettingCreate = "company-setting-create",
    CompanySettingDelete = "company-setting-delete",
    CompanySettingRead = "company-setting-read",
    CompanySettingUpdate = "company-setting-update",
    CompanyUpdate = "company-update",
    ContractTypeCreate = "contract-type-create",
    ContractTypeDelete = "contract-type-delete",
    ContractTypeRead = "contract-type-read",
    ContractTypeUpdate = "contract-type-update",
    CostCenterCreate = "cost-center-create",
    CostCenterDelete = "cost-center-delete",
    CostCenterRead = "cost-center-read",
    CostCenterUpdate = "cost-center-update",
    CountryCreate = "country-create",
    CountryDelete = "country-delete",
    CountryRead = "country-read",
    CountryUpdate = "country-update",
    CurrencyCreate = "currency-create",
    CurrencyDelete = "currency-delete",
    CurrencyRead = "currency-read",
    CurrencyUpdate = "currency-update",
    CziscoCreate = "czisco-create",
    CziscoDelete = "czisco-delete",
    CziscoRead = "czisco-read",
    CziscoUpdate = "czisco-update",
    DepartmentCreate = "department-create",
    DepartmentDelete = "department-delete",
    DepartmentRead = "department-read",
    DepartmentUpdate = "department-update",
    DepartmetCreate = "departmet-create",
    DepartmetDelete = "departmet-delete",
    DepartmetRead = "departmet-read",
    DepartmetUpdate = "departmet-update",
    DocumentLanguageCreate = "document-language-create",
    DocumentLanguageDelete = "document-language-delete",
    DocumentLanguageRead = "document-language-read",
    DocumentLanguageUpdate = "document-language-update",
    EducationCreate = "education-create",
    EducationDelete = "education-delete",
    EducationRead = "education-read",
    EducationUpdate = "education-update",
    EventTimerRead = "event-timer-read",
    EventTypeCreate = "event-type-create",
    EventTypeDelete = "event-type-delete",
    EventTypeRead = "event-type-read",
    EventTypeUpdate = "event-type-update",
    HeliousAccountantRead = "helious-accountant-read",
    HeliousEmptyDaysRead = "helious-empty-days-read",
    HeliousOperationRead = "helious-operation-read",
    HeliousReportRead = "helious-report-read",
    ImpersonateUsersRead = "impersonate-users-read",
    InsuranceCompanyCreate = "insurance-company-create",
    InsuranceCompanyDelete = "insurance-company-delete",
    InsuranceCompanyRead = "insurance-company-read",
    InsuranceCompanyUpdate = "insurance-company-update",
    LogRead = "log-read",
    LogSensitiveRead = "log-sensitive-read",
    ManagerReportAttendanceRead = "manager-report-attendance-read",
    ManagerReportEventRead = "manager-report-event-read",
    ManagerReportWorkreportRead = "manager-report-workreport-read",
    MealAllowanceReportRead = "meal-allowance-report-read",
    MonthlyFeedbackRead = "monthly-feedback-read",
    OperationCanHandleEventRead = "operation-can-handle-event-read",
    OperationCanHandleWorkreportRead = "operation-can-handle-workreport-read",
    OperationUserAttendanceCreate = "operation-user-attendance-create",
    OperationUserAttendanceRead = "operation-user-attendance-read",
    OperationUserAttendanceUpdate = "operation-user-attendance-update",
    OperationUserEventCreate = "operation-user-event-create",
    OperationUserEventDelete = "operation-user-event-delete",
    OperationUserEventRead = "operation-user-event-read",
    OperationUserEventUpdate = "operation-user-event-update",
    OperationUserWorkreportRead = "operation-user-workreport-read",
    PermissionCreate = "permission-create",
    PermissionDelete = "permission-delete",
    PermissionRead = "permission-read",
    PermissionUpdate = "permission-update",
    PermitTypeCreate = "permit-type-create",
    PermitTypeDelete = "permit-type-delete",
    PermitTypeRead = "permit-type-read",
    PermitTypeUpdate = "permit-type-update",
    PlaceCreate = "place-create",
    PlaceDelete = "place-delete",
    PlaceRead = "place-read",
    PlaceUpdate = "place-update",
    PositionCreate = "position-create",
    PositionDelete = "position-delete",
    PositionRead = "position-read",
    PositionTypeCreate = "position-type-create",
    PositionTypeDelete = "position-type-delete",
    PositionTypeRead = "position-type-read",
    PositionTypeUpdate = "position-type-update",
    PositionUpdate = "position-update",
    ProjectCreate = "project-create",
    ProjectDelete = "project-delete",
    ProjectRead = "project-read",
    ProjectTypeCreate = "project-type-create",
    ProjectTypeDelete = "project-type-delete",
    ProjectTypeRead = "project-type-read",
    ProjectTypeUpdate = "project-type-update",
    ProjectUpdate = "project-update",
    PublicHolidayCreate = "public-holiday-create",
    PublicHolidayDelete = "public-holiday-delete",
    PublicHolidayRead = "public-holiday-read",
    PublicHolidayUpdate = "public-holiday-update",
    ReportAttendanceRead = "report-attendance-read",
    ReportEventRead = "report-event-read",
    ReportMealAllowanceRead = "report-meal-allowance-read",
    ReportMealAllowanceUpdate = "report-meal-allowance-update",
    ReportWorkreportRead = "report-workreport-read",
    RolesCreate = "roles-create",
    RolesDelete = "roles-delete",
    RolesRead = "roles-read",
    RolesUpdate = "roles-update",
    SalaryTypeCreate = "salary-type-create",
    SalaryTypeDelete = "salary-type-delete",
    SalaryTypeRead = "salary-type-read",
    SalaryTypeUpdate = "salary-type-update",
    SubordinateListRead = "subordinate-list-read",
    SubsidyCreate = "subsidy-create",
    SubsidyDelete = "subsidy-delete",
    SubsidyRead = "subsidy-read",
    SubsidyUpdate = "subsidy-update",
    UserCanImpersonateRead = "user-can-impersonate-read",
    UserCanSwapContractUpdate = "user-can-swap-contract-update",
    UserCompanyVacationCreate = "user-company-vacation-create",
    UserCompanyVacationDelete = "user-company-vacation-delete",
    UserCompanyVacationRead = "user-company-vacation-read",
    UserCreate = "user-create",
    UserDeputyHistoryCreate = "user-deputy-history-create",
    UserDeputyHistoryDelete = "user-deputy-history-delete",
    UserDeputyHistoryOwnCreate = "user-deputy-history-own-create",
    UserDeputyHistoryOwnDelete = "user-deputy-history-own-delete",
    UserDeputyHistoryOwnRead = "user-deputy-history-own-read",
    UserDeputyHistoryRead = "user-deputy-history-read",
    UserOwnEventCreate = "user-own-event-create",
    UserOwnEventDelete = "user-own-event-delete",
    UserOwnEventRead = "user-own-event-read",
    UserOwnEventUpdate = "user-own-event-update",
    UserPermissionRead = "user-permission-read",
    UserProfile = "user-profile",
    UserProfileAccommodationHistoryCreate = "user-profile-accommodation-history-create",
    UserProfileAccommodationHistoryDelete = "user-profile-accommodation-history-delete",
    UserProfileAccommodationHistoryOwnCreate = "user-profile-accommodation-history-own-create",
    UserProfileAccommodationHistoryOwnDelete = "user-profile-accommodation-history-own-delete",
    UserProfileAccommodationHistoryOwnRead = "user-profile-accommodation-history-own-read",
    UserProfileAccommodationHistoryRead = "user-profile-accommodation-history-read",
    UserProfileAfTabOwnRead = "user-profile-af-tab-own-read",
    UserProfileAfTabRead = "user-profile-af-tab-read",
    UserProfileAfTabSubordinateRead = "user-profile-af-tab-subordinate-read",
    UserProfileBirthdayOwnRead = "user-profile-birthday-own-read",
    UserProfileBirthdayOwnUpdate = "user-profile-birthday-own-update",
    UserProfileBirthdayRead = "user-profile-birthday-read",
    UserProfileBirthdayUpdate = "user-profile-birthday-update",
    UserProfileBudgetOwnRead = "user-profile-budget-own-read",
    UserProfileBudgetOwnUpdate = "user-profile-budget-own-update",
    UserProfileBudgetRead = "user-profile-budget-read",
    UserProfileBudgetUpdate = "user-profile-budget-update",
    UserProfileChangelogTabOwnRead = "user-profile-changelog-tab-own-read",
    UserProfileChangelogTabRead = "user-profile-changelog-tab-read",
    UserProfileChangelogTabSubordinateRead = "user-profile-changelog-tab-subordinate-read",
    UserProfileCoefficientHistoryCreate = "user-profile-coefficient-history-create",
    UserProfileCoefficientHistoryDelete = "user-profile-coefficient-history-delete",
    UserProfileCoefficientHistoryOwnCreate = "user-profile-coefficient-history-own-create",
    UserProfileCoefficientHistoryOwnDelete = "user-profile-coefficient-history-own-delete",
    UserProfileCoefficientHistoryOwnRead = "user-profile-coefficient-history-own-read",
    UserProfileCoefficientHistoryRead = "user-profile-coefficient-history-read",
    UserProfileCompanyEmailOwnRead = "user-profile-company-email-own-read",
    UserProfileCompanyEmailOwnUpdate = "user-profile-company-email-own-update",
    UserProfileCompanyEmailRead = "user-profile-company-email-read",
    UserProfileCompanyEmailUpdate = "user-profile-company-email-update",
    UserProfileCompanyHistoryCreate = "user-profile-company-history-create",
    UserProfileCompanyHistoryDelete = "user-profile-company-history-delete",
    UserProfileCompanyHistoryOwnCreate = "user-profile-company-history-own-create",
    UserProfileCompanyHistoryOwnDelete = "user-profile-company-history-own-delete",
    UserProfileCompanyHistoryOwnRead = "user-profile-company-history-own-read",
    UserProfileCompanyHistoryRead = "user-profile-company-history-read",
    UserProfileCompanyPhoneOwnRead = "user-profile-company-phone-own-read",
    UserProfileCompanyPhoneOwnUpdate = "user-profile-company-phone-own-update",
    UserProfileCompanyPhoneRead = "user-profile-company-phone-read",
    UserProfileCompanyPhoneUpdate = "user-profile-company-phone-update",
    UserProfileContractAddressHistoryCreate = "user-profile-contract-address-history-create",
    UserProfileContractAddressHistoryDelete = "user-profile-contract-address-history-delete",
    UserProfileContractAddressHistoryOwnCreate = "user-profile-contract-address-history-own-create",
    UserProfileContractAddressHistoryOwnDelete = "user-profile-contract-address-history-own-delete",
    UserProfileContractAddressHistoryOwnRead = "user-profile-contract-address-history-own-read",
    UserProfileContractAddressHistoryRead = "user-profile-contract-address-history-read",
    UserProfileContractAddressOwnRead = "user-profile-contract-address-own-read",
    UserProfileContractAddressRead = "user-profile-contract-address-read",
    UserProfileContractAmendmentCreate = "user-profile-contract-amendment-create",
    UserProfileContractAmendmentDelete = "user-profile-contract-amendment-delete",
    UserProfileContractAmendmentOwnCreate = "user-profile-contract-amendment-own-create",
    UserProfileContractAmendmentOwnRead = "user-profile-contract-amendment-own-read",
    UserProfileContractAmendmentOwnUpdate = "user-profile-contract-amendment-own-update",
    UserProfileContractAmendmentRead = "user-profile-contract-amendment-read",
    UserProfileContractAmendmentUpdate = "user-profile-contract-amendment-update",
    UserProfileContractCreate = "user-profile-contract-create",
    UserProfileContractOwnCreate = "user-profile-contract-own-create",
    UserProfileContractOwnRead = "user-profile-contract-own-read",
    UserProfileContractOwnUpdate = "user-profile-contract-own-update",
    UserProfileContractRead = "user-profile-contract-read",
    UserProfileContractTypeOwnRead = "user-profile-contract-type-own-read",
    UserProfileContractTypeRead = "user-profile-contract-type-read",
    UserProfileContractUpdate = "user-profile-contract-update",
    UserProfileCostcenterHistoryCreate = "user-profile-costcenter-history-create",
    UserProfileCostcenterHistoryDelete = "user-profile-costcenter-history-delete",
    UserProfileCostcenterHistoryOwnCreate = "user-profile-costcenter-history-own-create",
    UserProfileCostcenterHistoryOwnDelete = "user-profile-costcenter-history-own-delete",
    UserProfileCostcenterHistoryOwnRead = "user-profile-costcenter-history-own-read",
    UserProfileCostcenterHistoryRead = "user-profile-costcenter-history-read",
    UserProfileCountryOwnRead = "user-profile-country-own-read",
    UserProfileCountryOwnUpdate = "user-profile-country-own-update",
    UserProfileCountryRead = "user-profile-country-read",
    UserProfileCountryUpdate = "user-profile-country-update",
    UserProfileCurrentAccommodationOwnRead = "user-profile-current-accommodation-own-read",
    UserProfileCurrentAccommodationRead = "user-profile-current-accommodation-read",
    UserProfileCurrentCoefficientOwnRead = "user-profile-current-coefficient-own-read",
    UserProfileCurrentCoefficientRead = "user-profile-current-coefficient-read",
    UserProfileCurrentCompanyOwnRead = "user-profile-current-company-own-read",
    UserProfileCurrentJiraKeyOwnRead = "user-profile-current-jira-key-own-read",
    UserProfileCurrentHrNotesOwnRead = "user-profile-current-hr-notes-own-read",
    UserProfileCurrentCompanyRead = "user-profile-current-company-read",
    UserProfileCurrentJiraKeyRead = "user-profile-current-jira-key-read",
    UserProfileCurrentHrNotesRead = "user-profile-current-hr-notes-read",
    UserProfileCurrentCostcenterOwnRead = "user-profile-current-costcenter-own-read",
    UserProfileCurrentCostcenterRead = "user-profile-current-costcenter-read",
    UserProfileCurrentDepartmentOwnRead = "user-profile-current-department-own-read",
    UserProfileCurrentDepartmentRead = "user-profile-current-department-read",
    UserProfileCurrentDeputyOwnRead = "user-profile-current-deputy-own-read",
    UserProfileCurrentDeputyRead = "user-profile-current-deputy-read",
    UserProfileCurrentGeneralPractitionerOwnRead = "user-profile-current-general-practitioner-own-read",
    UserProfileCurrentGeneralPractitionerRead = "user-profile-current-general-practitioner-read",
    UserProfileCurrentHrbpOwnRead = "user-profile-current-hrbp-own-read",
    UserProfileCurrentHrbpRead = "user-profile-current-hrbp-read",
    UserProfileCurrentInsuranceCompanyOwnRead = "user-profile-current-insurance-company-own-read",
    UserProfileCurrentInsuranceCompanyRead = "user-profile-current-insurance-company-read",
    UserProfileCurrentManagerOwnRead = "user-profile-current-manager-own-read",
    UserProfileCurrentManagerRead = "user-profile-current-manager-read",
    UserProfileCurrentMealallowanceCreate = "user-profile-current-mealallowance-create",
    UserProfileCurrentMealallowanceDelete = "user-profile-current-mealallowance-delete",
    UserProfileCurrentMealallowanceOwnCreate = "user-profile-current-mealallowance-own-create",
    UserProfileCurrentMealallowanceOwnDelete = "user-profile-current-mealallowance-own-delete",
    UserProfileCurrentMealallowanceOwnRead = "user-profile-current-mealallowance-own-read",
    UserProfileCurrentMealallowanceRead = "user-profile-current-mealallowance-read",
    UserProfileCurrentPermitOwnRead = "user-profile-current-permit-own-read",
    UserProfileCurrentPermitRead = "user-profile-current-permit-read",
    UserProfileCurrentPlaceOwnRead = "user-profile-current-place-own-read",
    UserProfileCurrentPlaceRead = "user-profile-current-place-read",
    UserProfileCurrentPnoOwnRead = "user-profile-current-pno-own-read",
    UserProfileCurrentPnoRead = "user-profile-current-pno-read",
    UserProfileCurrentPositionOwnRead = "user-profile-current-position-own-read",
    UserProfileCurrentPositionRead = "user-profile-current-position-read",
    UserProfileCurrentProjectOwnRead = "user-profile-current-project-own-read",
    UserProfileCurrentProjectRead = "user-profile-current-project-read",
    UserProfileCurrentProjectleadOwnRead = "user-profile-current-projectlead-own-read",
    UserProfileCurrentProjectleadRead = "user-profile-current-projectlead-read",
    UserProfileCurrentSalaryOwnRead = "user-profile-current-salary-own-read",
    UserProfileCurrentSalaryRead = "user-profile-current-salary-read",
    UserProfileCurrentWorkingHoursOwnRead = "user-profile-current-working-hours-own-read",
    UserProfileCurrentWorkingHoursRead = "user-profile-current-working-hours-read",
    UserProfileCziscoOwnRead = "user-profile-czisco-own-read",
    UserProfileCziscoRead = "user-profile-czisco-read",
    UserProfileDepartmentHistoryCreate = "user-profile-department-history-create",
    UserProfileDepartmentHistoryDelete = "user-profile-department-history-delete",
    UserProfileDepartmentHistoryOwnCreate = "user-profile-department-history-own-create",
    UserProfileDepartmentHistoryOwnDelete = "user-profile-department-history-own-delete",
    UserProfileDepartmentHistoryOwnRead = "user-profile-department-history-own-read",
    UserProfileDepartmentHistoryRead = "user-profile-department-history-read",
    UserProfileDocumentLanguageOwnRead = "user-profile-document-language-own-read",
    UserProfileDocumentLanguageRead = "user-profile-document-language-read",
    UserProfileDocumentlanguageHistoryCreate = "user-profile-documentlanguage-history-create",
    UserProfileDocumentlanguageHistoryDelete = "user-profile-documentlanguage-history-delete",
    UserProfileDocumentlanguageHistoryOwnCreate = "user-profile-documentlanguage-history-own-create",
    UserProfileDocumentlanguageHistoryOwnDelete = "user-profile-documentlanguage-history-own-delete",
    UserProfileDocumentlanguageHistoryOwnRead = "user-profile-documentlanguage-history-own-read",
    UserProfileDocumentlanguageHistoryRead = "user-profile-documentlanguage-history-read",
    UserProfileEducationHistoryCreate = "user-profile-education-history-create",
    UserProfileEducationHistoryDelete = "user-profile-education-history-delete",
    UserProfileEducationHistoryOwnCreate = "user-profile-education-history-own-create",
    UserProfileEducationHistoryOwnDelete = "user-profile-education-history-own-delete",
    UserProfileEducationHistoryOwnRead = "user-profile-education-history-own-read",
    UserProfileEducationHistoryRead = "user-profile-education-history-read",
    UserProfileEducationOwnRead = "user-profile-education-own-read",
    UserProfileEducationRead = "user-profile-education-read",
    UserProfileGenderOwnRead = "user-profile-gender-own-read",
    UserProfileGenderOwnUpdate = "user-profile-gender-own-update",
    UserProfileGenderRead = "user-profile-gender-read",
    UserProfileGenderUpdate = "user-profile-gender-update",
    UserProfileGeneralPractitionerHistoryCreate = "user-profile-general-practitioner-history-create",
    UserProfileGeneralPractitionerHistoryDelete = "user-profile-general-practitioner-history-delete",
    UserProfileGeneralPractitionerHistoryOwnCreate = "user-profile-general-practitioner-history-own-create",
    UserProfileGeneralPractitionerHistoryOwnDelete = "user-profile-general-practitioner-history-own-delete",
    UserProfileGeneralPractitionerHistoryOwnRead = "user-profile-general-practitioner-history-own-read",
    UserProfileGeneralPractitionerHistoryRead = "user-profile-general-practitioner-history-read",
    UserProfileHistoryTabOwnRead = "user-profile-history-tab-own-read",
    UserProfileHistoryTabRead = "user-profile-history-tab-read",
    UserProfileHistoryTabSubordinateRead = "user-profile-history-tab-subordinate-read",
    UserProfileHrbpHistoryCreate = "user-profile-hrbp-history-create",
    UserProfileHrbpHistoryDelete = "user-profile-hrbp-history-delete",
    UserProfileHrbpHistoryOwnCreate = "user-profile-hrbp-history-own-create",
    UserProfileHrbpHistoryOwnDelete = "user-profile-hrbp-history-own-delete",
    UserProfileHrbpHistoryOwnRead = "user-profile-hrbp-history-own-read",
    UserProfileHrbpHistoryRead = "user-profile-hrbp-history-read",
    UserProfileInsuranceCompanyHistoryCreate = "user-profile-insurance-company-history-create",
    UserProfileInsuranceCompanyHistoryDelete = "user-profile-insurance-company-history-delete",
    UserProfileInsuranceCompanyHistoryOwnCreate = "user-profile-insurance-company-history-own-create",
    UserProfileInsuranceCompanyHistoryOwnDelete = "user-profile-insurance-company-history-own-delete",
    UserProfileInsuranceCompanyHistoryOwnRead = "user-profile-insurance-company-history-own-read",
    UserProfileInsuranceCompanyHistoryRead = "user-profile-insurance-company-history-read",
    UserProfileManagerHistoryCreate = "user-profile-manager-history-create",
    UserProfileManagerHistoryDelete = "user-profile-manager-history-delete",
    UserProfileManagerHistoryOwnCreate = "user-profile-manager-history-own-create",
    UserProfileManagerHistoryOwnDelete = "user-profile-manager-history-own-delete",
    UserProfileManagerHistoryOwnRead = "user-profile-manager-history-own-read",
    UserProfileManagerHistoryRead = "user-profile-manager-history-read",
    UserProfileMealallowanceHistoryCreate = "user-profile-mealallowance-history-create",
    UserProfileMealallowanceHistoryDelete = "user-profile-mealallowance-history-delete",
    UserProfileMealallowanceHistoryOwnCreate = "user-profile-mealallowance-history-own-create",
    UserProfileMealallowanceHistoryOwnDelete = "user-profile-mealallowance-history-own-delete",
    UserProfileMealallowanceHistoryOwnRead = "user-profile-mealallowance-history-own-read",
    UserProfileMealallowanceHistoryRead = "user-profile-mealallowance-history-read",
    UserProfileNationalityOwnRead = "user-profile-nationality-own-read",
    UserProfileNationalityRead = "user-profile-nationality-read",
    UserProfileOperatingOfficeRead = "user-profile-operating-office-read",
    UserProfileOperatingOfficeUpdate = "user-profile-operating-office-update",
    UserProfileOrgTabOwnRead = "user-profile-org-tab-own-read",
    UserProfileOrgTabRead = "user-profile-org-tab-read",
    UserProfileOrgTabSubordinateRead = "user-profile-org-tab-subordinate-read",
    UserProfilePermanentAddressHistoryCreate = "user-profile-permanent-address-history-create",
    UserProfilePermanentAddressHistoryDelete = "user-profile-permanent-address-history-delete",
    UserProfilePermanentAddressHistoryOwnCreate = "user-profile-permanent-address-history-own-create",
    UserProfilePermanentAddressHistoryOwnDelete = "user-profile-permanent-address-history-own-delete",
    UserProfilePermanentAddressHistoryOwnRead = "user-profile-permanent-address-history-own-read",
    UserProfilePermanentAddressHistoryRead = "user-profile-permanent-address-history-read",
    UserProfilePermanentAddressOwnRead = "user-profile-permanent-address-own-read",
    UserProfilePermanentAddressRead = "user-profile-permanent-address-read",
    UserProfilePermitHistoryCreate = "user-profile-permit-history-create",
    UserProfilePermitHistoryDelete = "user-profile-permit-history-delete",
    UserProfilePermitHistoryOwnCreate = "user-profile-permit-history-own-create",
    UserProfilePermitHistoryOwnDelete = "user-profile-permit-history-own-delete",
    UserProfilePermitHistoryOwnRead = "user-profile-permit-history-own-read",
    UserProfilePermitHistoryRead = "user-profile-permit-history-read",
    UserProfilePersonalEmailOwnRead = "user-profile-personal-email-own-read",
    UserProfilePersonalEmailOwnUpdate = "user-profile-personal-email-own-update",
    UserProfilePersonalEmailRead = "user-profile-personal-email-read",
    UserProfilePersonalEmailUpdate = "user-profile-personal-email-update",
    UserProfilePersonalIdentificationNumberOwnRead = "user-profile-personal-identification-number-own-read",
    UserProfilePersonalIdentificationNumberOwnUpdate = "user-profile-personal-identification-number-own-update",
    UserProfilePersonalIdentificationNumberRead = "user-profile-personal-identification-number-read",
    UserProfilePersonalIdentificationNumberUpdate = "user-profile-personal-identification-number-update",
    UserProfilePersonalPhoneOwnPrivacyRead = "user-profile-personal-phone-own-privacy-read",
    UserProfilePersonalPhoneOwnPrivacyUpdate = "user-profile-personal-phone-own-privacy-update",
    UserProfilePersonalPhoneOwnRead = "user-profile-personal-phone-own-read",
    UserProfilePersonalPhoneOwnUpdate = "user-profile-personal-phone-own-update",
    UserProfilePersonalPhoneRead = "user-profile-personal-phone-read",
    UserProfilePersonalPhoneUpdate = "user-profile-personal-phone-update",
    UserProfilePlaceHistoryCreate = "user-profile-place-history-create",
    UserProfilePlaceHistoryDelete = "user-profile-place-history-delete",
    UserProfilePlaceHistoryOwnCreate = "user-profile-place-history-own-create",
    UserProfilePlaceHistoryOwnDelete = "user-profile-place-history-own-delete",
    UserProfilePlaceHistoryOwnRead = "user-profile-place-history-own-read",
    UserProfilePlaceHistoryRead = "user-profile-place-history-read",
    UserProfilePositionHistoryCreate = "user-profile-position-history-create",
    UserProfilePositionHistoryDelete = "user-profile-position-history-delete",
    UserProfilePositionHistoryOwnCreate = "user-profile-position-history-own-create",
    UserProfilePositionHistoryOwnDelete = "user-profile-position-history-own-delete",
    UserProfilePositionHistoryOwnRead = "user-profile-position-history-own-read",
    UserProfilePositionHistoryRead = "user-profile-position-history-read",
    UserProfileProjectHistoryCreate = "user-profile-project-history-create",
    UserProfileProjectHistoryDelete = "user-profile-project-history-delete",
    UserProfileProjectHistoryOwnCreate = "user-profile-project-history-own-create",
    UserProfileProjectHistoryOwnDelete = "user-profile-project-history-own-delete",
    UserProfileProjectHistoryOwnRead = "user-profile-project-history-own-read",
    UserProfileProjectHistoryRead = "user-profile-project-history-read",
    UserProfileProjectleadHistoryCreate = "user-profile-projectlead-history-create",
    UserProfileProjectleadHistoryDelete = "user-profile-projectlead-history-delete",
    UserProfileProjectleadHistoryOwnCreate = "user-profile-projectlead-history-own-create",
    UserProfileProjectleadHistoryOwnDelete = "user-profile-projectlead-history-own-delete",
    UserProfileProjectleadHistoryOwnRead = "user-profile-projectlead-history-own-read",
    UserProfileProjectleadHistoryRead = "user-profile-projectlead-history-read",
    UserProfileReferralCreate = "user-profile-referral-create",
    UserProfileReferralJiraLinkRead = "user-profile-referral-jira-link-read",
    UserProfileReferralOwnCreate = "user-profile-referral-own-create",
    UserProfileReferralOwnRead = "user-profile-referral-own-read",
    UserProfileReferralOwnUpdate = "user-profile-referral-own-update",
    UserProfileReferralRead = "user-profile-referral-read",
    UserProfileReferralTabOwnRead = "user-profile-referral-tab-own-read",
    UserProfileReferralTabRead = "user-profile-referral-tab-read",
    UserProfileReferralTabSubordinateRead = "user-profile-referral-tab-subordinate-read",
    UserProfileReferralUpdate = "user-profile-referral-update",
    UserProfileRoleOwnRead = "user-profile-role-own-read",
    UserProfileRoleOwnUpdate = "user-profile-role-own-update",
    UserProfileRoleRead = "user-profile-role-read",
    UserProfileRoleUpdate = "user-profile-role-update",
    UserProfileSalaryHistoryCreate = "user-profile-salary-history-create",
    UserProfileSalaryHistoryDelete = "user-profile-salary-history-delete",
    UserProfileSalaryHistoryOwnCreate = "user-profile-salary-history-own-create",
    UserProfileSalaryHistoryOwnDelete = "user-profile-salary-history-own-delete",
    UserProfileSalaryHistoryOwnRead = "user-profile-salary-history-own-read",
    UserProfileSalaryHistoryRead = "user-profile-salary-history-read",
    UserProfileSubsidyHistoryCreate = "user-profile-subsidy-history-create",
    UserProfileSubsidyHistoryDelete = "user-profile-subsidy-history-delete",
    UserProfileSubsidyHistoryOwnCreate = "user-profile-subsidy-history-own-create",
    UserProfileSubsidyHistoryOwnDelete = "user-profile-subsidy-history-own-delete",
    UserProfileSubsidyHistoryOwnRead = "user-profile-subsidy-history-own-read",
    UserProfileSubsidyHistoryRead = "user-profile-subsidy-history-read",
    UserProfileTopTalentOwnRead = "user-profile-top-talent-own-read",
    UserProfileTopTalentRead = "user-profile-top-talent-read",
    UserProfileToptalentHistoryCreate = "user-profile-toptalent-history-create",
    UserProfileToptalentHistoryDelete = "user-profile-toptalent-history-delete",
    UserProfileToptalentHistoryOwnCreate = "user-profile-toptalent-history-own-create",
    UserProfileToptalentHistoryOwnDelete = "user-profile-toptalent-history-own-delete",
    UserProfileToptalentHistoryOwnRead = "user-profile-toptalent-history-own-read",
    UserProfileToptalentHistoryRead = "user-profile-toptalent-history-read",
    UserProfileVacationTabOwnRead = "user-profile-vacation-tab-own-read",
    UserProfileVacationTabRead = "user-profile-vacation-tab-read",
    UserProfileVacationTabSubordinateRead = "user-profile-vacation-tab-subordinate-read",
    UserProfileWorkingHoursHistoryCreate = "user-profile-working-hours-history-create",
    UserProfileWorkingHoursHistoryDelete = "user-profile-working-hours-history-delete",
    UserProfileWorkingHoursHistoryOwnCreate = "user-profile-working-hours-history-own-create",
    UserProfileWorkingHoursHistoryOwnDelete = "user-profile-working-hours-history-own-delete",
    UserProfileWorkingHoursHistoryOwnRead = "user-profile-working-hours-history-own-read",
    UserProfileWorkingHoursHistoryRead = "user-profile-working-hours-history-read",
    UserRead = "user-read",
    UserStatusUpdate = "user-status-update",
    UserUpdate = "user-update",
    WorkreportRead = "workreport-read",
    WorkreportShow = "workreport-show",
}
